import React from 'react';
import Src from './Src';
import Name from './Name';
import Active from './Active';
import HasBadge from './HasBadge';


const AvatarComponent = () => {
  return (
    <div className="m-3">
      <h3>Avatars</h3>
      <Src />
      <Name />
      <Active />
      <HasBadge />
    </div>
  );
};

export default AvatarComponent;
